import { IScheduling } from 'app/shared/model/scheduling.model';

export interface IGasSupply {
  id?: number;
  volume?: string | null;
  price?: string | null;
  distance?: string | null;
  scheduling?: IScheduling | null;
  createdBy?: string | null;
}

export const defaultValue: Readonly<IGasSupply> = {};
